import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { TableStateType } from 'hooks';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

export const useTableStateChange = <T extends object>(
  updateTableState: ActionCreatorWithPayload<TableStateType<T>>
) => {
  const dispatch = useDispatch();

  return useCallback(
    ({ pageSize, pageIndex, sortBy }: TableStateType<T>) => {
      dispatch(
        updateTableState({
          pageSize,
          pageIndex,
          sortBy,
        })
      );
    },
    [dispatch, updateTableState]
  );
};
